<template>
  <div
    class="em-field-group"
    :class="{ required: required, disabled: disabled, 'has-error': errorText }"
  >
    <label v-if="label" class="field-label">
      {{ label }}
      <span v-if="required" class="required-indicator">*</span>
    </label>
    <div class="field-content">
      <slot />
    </div>
    <p v-if="hint && !errorText" class="field-hint">{{ hint }}</p>
    <p v-if="errorText" class="field-error">{{ errorText }}</p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label?: string;
  hint?: string;
  errorText?: string;
  required?: boolean;
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  required: false,
  disabled: false,
});
</script>

<style scoped>
.em-field-group {
  gap: 6px;
}

.field-label {
  font-size: 15px;
  font-weight: 400;
  color: var(--ion-text-color);
}

.required-indicator {
  color: var(--ion-color-danger, #eb445a);
  margin-left: 2px;
}

.field-content {
  width: 100%;
}

.field-hint {
  font-size: 12px;
  color: var(--ion-text-color-tertiary, #999);
  margin: 0;
}

.field-error {
  font-size: 12px;
  color: var(--ion-color-danger, #eb445a);
  margin: 0;
}

.em-field-group.disabled .field-label {
  opacity: 0.6;
}

.em-field-group.has-error .field-label {
  color: var(--ion-color-danger, #eb445a);
}
</style>
